module.exports = __webpack_public_path__ + "0b6f6bdc94b4d06787ce0e18e3cd1233.png";